// PEC-1557 — Microsoft Clarity para el webmail embebido en Lexon (iframe).
// Mismo modelo que Asistente-Lexon (frontend/src/analytics/clarity.ts). La grabación es
// opt-in por cuatro puertas, todas comprobadas aquí:
//  - solo en producción (window.REACT_APP_ENVIRONMENT === 'PRO'): dev, pre y local nunca cargan el tag;
//  - solo si el token de entrada de Lexon trae accept_cookies === true (UserUtils lo emite como claim);
//  - solo embebido (iframe); fuera del iframe manda Cookiebot, como siempre;
//  - nunca mientras el JWT de entrada viaje en la URL (/access/<token>): Clarity captura
//    location.href y ese token da acceso al buzón. Se espera a la redirección a /calendar.
// Decisiones de privacidad heredadas del asistente: consentimiento v2 solo analítica (ad_Storage
// denegado), identify con el id de usuario de Lexon (Clarity lo hashea) sin nombre, y etiqueta
// user_type=internal|external|unknown según window.CLARITY_INTERNAL_USERS para poder filtrar al
// grupo en Clarity y no contaminar las métricas. La analítica nunca debe romper la app.

export const isProduction = () => window.REACT_APP_ENVIRONMENT === 'PRO';

export const isTokenInUrl = (pathname = window.location.pathname) => /\/access\//.test(pathname);

export const shouldStartClarity = ({
  embedded,
  acceptCookies,
  production = isProduction(),
  tokenInUrl = isTokenInUrl()
}) => embedded === true && acceptCookies === true && production === true && tokenInUrl === false;

// Lista configurable en runtime (ConfigMap / envsubst): dominios (lefebvre.es), emails exactos
// (x@y.com) o idClienteNavision (E1660489), separados por comas. Vacía = clasificación no configurada.
export const parseInternalList = (raw = window.CLARITY_INTERNAL_USERS) =>
  String(raw || '')
    .split(',')
    .map(entry => entry.trim().toLowerCase())
    .filter(Boolean);

export const classifyUser = ({ account, idClienteNavision } = {}, entries = parseInternalList()) => {
  if (entries.length === 0) return '';
  const email = String(account || '').trim().toLowerCase();
  const navision = String(idClienteNavision || '').trim().toLowerCase();
  if (!email && !navision) return 'unknown';
  const domain = email.includes('@') ? email.split('@').pop() : '';
  const candidates = [email, domain, navision].filter(Boolean);
  return entries.some(entry => candidates.includes(entry)) ? 'internal' : 'external';
};

// Arranca la grabación: `init` inyecta el tag (window.clarity queda como cola hasta que cargue),
// después consentimiento solo analítica, identify y etiquetas. Devuelve true si arrancó.
export const startClarityForLexon = ({ init, user = {} }) => {
  try {
    init();
    if (typeof window.clarity !== 'function') return false;
    window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' });
    if (user.idUser) window.clarity('identify', String(user.idUser));
    const tags = [
      ['company', user.idCompany],
      ['user_type', classifyUser(user)]
    ];
    tags.forEach(([key, value]) => {
      if (value) window.clarity('set', key, String(value));
    });
    console.log('[clarity] grabación iniciada en el iframe de Lexon');
    return true;
  } catch (error) {
    console.warn('[clarity] la grabación no se ha podido iniciar', error);
    return false;
  }
};

export const stopClarityForLexon = () => {
  try {
    if (typeof window.clarity === 'function') {
      window.clarity('consent', false);
      window.clarity('stop');
    }
  } catch (error) {
    console.warn('[clarity] no se ha podido detener la grabación', error);
  }
};
